import { render, staticRenderFns } from "./SupplementPromptManagement.vue?vue&type=template&id=68c676e0&scoped=true&"
import script from "./SupplementPromptManagement.vue?vue&type=script&lang=js&"
export * from "./SupplementPromptManagement.vue?vue&type=script&lang=js&"
import style0 from "./SupplementPromptManagement.vue?vue&type=style&index=0&id=68c676e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c676e0",
  null
  
)

export default component.exports